module.exports = __webpack_public_path__ + "media/images/plus-a00551d6.svg";